var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAxisZ(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 5,
    height: 7,
    viewBox: "0 0 5 7",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.854 5.28016V6.16016H0.078V5.46416L3.374 1.44016H0.134V0.560156H4.75V1.25616L1.454 5.28016H4.854Z",
    fill: "#ACAFB9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAxisZ);
export default __webpack_public_path__ + "static/media/axis_z.110ea472d87361ff72d7086abac810a2.svg";
export { ForwardRef as ReactComponent };